import { call } from 'redux-saga/effects';
import { board } from 'utils/whiteboard/BoardStateManager';
import type { userNameDecrypted } from 'features/e2ee/actions';

export function* onUserNameDecryptedSaga(action: ReturnType<typeof userNameDecrypted>) {
  const { id, name } = action.payload;

  yield call(board.renamePointer, id, name);
}
